<template>
    <div>
        <div
            class="vehicle--search"
            :class="
                !strema
                    ? 'vehicle--search--minheight'
                    : 'vehicle--search--fullheight'
            "
        >
            <div class="plate--country">
                <v-select
                    class="select-countries-plate"
                    v-model="countrySelected"
                    :items="
                        countryCodes.map((el) => ({
                            text: el.display,
                            value: el.value,
                        }))
                    "
                    hide-details
                    solo
                    @click="onPlateBlur"
                    @change="onChangePlateCountry()"
                />
            </div>
            <div
                class="box__vehicle--search"
                :class="
                    !strema
                        ? 'box__vehicle--search--minwidth'
                        : 'box__vehicle--search--fullwidth'
                "
            >
                <input
                    ref="input_plate_component"
                    type="text"
                    @change="onPlateChanged"
                    @keyup.enter="onPlateSearched"
                    id="plate-number-search"
                    data-cy="plate-sidebar"
                    v-mask="getMaskByDataSourceId(countrySelected)"
                    v-model="plateSelected"
                    :placeholder="getPlaceholderByDataSourceId(countrySelected)"
                    autocomplete="off"
                    @blur="onPlateBlur"
                />

                <div
                    v-if="!showClearIcon"
                    :key="key"
                    @click="onPlateSearched"
                    class="btn-icon-search"
                    data-cy="search-button-sidebar"
                >
                    <img
                        src="/images/_templates/icon-search.svg"
                        onload="SVGInject(this)"
                    />
                </div>
                <div
                    v-if="showClearIcon"
                    :key="key"
                    @click="onPlateCleared()"
                    class="btn-icon-clear"
                >
                    <img
                        src="/images/_templates/close.svg"
                        onload="SVGInject(this)"
                    />
                </div>
            </div>
            <div
                v-if="!strema"
                @click="toggleSearchHistory()"
                class="btn-open-history"
            >
                <img
                    src="/images/_templates/icon-file.svg"
                    onload="SVGInject(this)"
                />
            </div>
        </div>

        <history-component
            :show="showHistory"
            @plate-selected="historyPlateSelected($event)"
            @clicked-outside="clickedOutsideHistory()"
        />
    </div>
</template>

<script>
import { trimPlate, getMask, getPlaceholder } from "@src/utils/datasource.js";

export default {
    components: {
        HistoryComponent: () =>
            import(
                "@components/shared/widgets/vehicle-identification/HistoryComponent"
            ),
    },
    props: {
        country: {
            type: String,
            default: "1",
        },
        plate: {
            type: String | Object,
            required: true,
        },
        strema: {
            type: Boolean,
            default: false,
        },
        showClear: {
            type: Boolean,
            default: false,
            required: false,
        },
        showHistoryButton: {
            type: Boolean,
            default: true,
            required: false,
        },
    },
    data() {
        return {
            key: 0,
            showHistory: false,
            plateSelected: this.plate,
            countrySelected: this.country,
            iconClicked: false,
        };
    },
    computed: {
        computedVehicle() {
            return this.$store.getters["vehicleIdentification/getState"]
                .processNumber;
        },
        computedVehicleInfo() {
            return this.$store.getters["vehicleIdentification/getState"];
        },
        countryCodes() {
            return this.$store.getters["auth/getState"].dataSources || [];
        },
        showClearIcon() {
            let trimmedVehiclePlate = trimPlate(
                this.computedVehicleInfo.plateNumber
            ).toLowerCase();
            let trimmedPlate = trimPlate(this.plateSelected).toLowerCase();
            return (
                (this.strema && this.showClear) ||
                (!this.strema &&
                    this.computedVehicle &&
                    !trimmedVehiclePlate &&
                    !trimmedPlate) ||
                (!this.strema &&
                    this.computedVehicle &&
                    this.plateSelected &&
                    trimmedVehiclePlate == trimmedPlate)
            );
        },
    },
    watch: {
        showClearIcon: {
            handler: function (newValue) {
                this.key++;
            },
            deep: true,
            immediate: true,
        },
        plate: {
            handler: function (newValue) {
                if (typeof newValue == "string") {
                    this.plateSelected = newValue;
                }
            },
            deep: true,
            immediate: true,
        },
        country: {
            handler: function (newValue) {
                if (typeof newValue === "string") {
                    this.countrySelected = newValue;
                }
                return newValue;
            },
            deep: true,
            immediate: true,
        },
        computedVehicle: {
            handler: function (newValue) {
                if (!newValue) {
                    this.plateSelected = "";
                }
            },
        },
    },
    methods: {
        onPlateBlur() {
            setTimeout(() => {
                let loadedVehicle =
                    this.$store.getters["vehicleIdentification/getState"];
                if (!this.iconClicked) {
                    if (
                        loadedVehicle.processNumber &&
                        loadedVehicle.plateNumber &&
                        trimPlate(this.plateSelected).toLowerCase() !=
                            trimPlate(loadedVehicle.plateNumber).toLowerCase()
                    ) {
                        this.plateSelected = loadedVehicle.plateNumber;
                    }
                } else {
                    this.iconClicked = false;
                }
            }, 100);
        },
        getMaskByDataSourceId(dataSourceId) {
            return getMask(dataSourceId);
        },
        getPlaceholderByDataSourceId(dataSourceId) {
            return getPlaceholder(dataSourceId);
        },
        onPlateSearched() {
            this.iconClicked = true;
            this.$emit("on-plate-searched", {
                plate: this.plateSelected,
                dataSourceId: this.countrySelected,
            });
        },
        onChangePlateCountry() {
            this.$emit("on-country-changed", this.countrySelected);
        },
        historyPlateSelected(event) {
            this.$emit("on-history-plate-selected", event);
            this.clickedOutsideHistory();
        },
        toggleSearchHistory() {
            this.showHistory = !this.showHistory;
        },
        clickedOutsideHistory() {
            this.showHistory = false;
        },
        onPlateCleared() {
            this.$emit("on-plate-cleared");
        },
        onPlateChanged() {
            this.$emit("on-plate-changed", this.plateSelected);
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
.component__Vehicle--Search {
    .vehicle--search--minheight {
        height: 40px;
    }

    .vehicle--search--fullheight {
        height: 56px;
    }

    .vehicle--search {
        display: flex;

        .plate--country {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 100%;
            font-size: 20px;
            font-weight: 500;
            color: #ffffff;
            background: var(--v-primary-base);
            border: 0;
            border-top-left-radius: 7px;
            border-bottom-left-radius: 7px;

            .select-countries-plate {
                width: 40px;
                height: 100%;
                font-size: 20px;
                font-weight: 500;
                color: #ffffff;
                background: var(--v-primary-base);
                border: 0;
                border-top-left-radius: 7px;
                border-bottom-left-radius: 7px;
                text-align: center;
                outline: none;

                .v-input__control {
                    height: 100%;
                    min-height: 100%;
                    .v-input__slot {
                        height: 100%;
                        padding: 0px !important;
                        box-shadow: none !important;
                        background: transparent !important;

                        .v-select__selections {
                            position: absolute !important;
                            left: 35%;
                            color: #fff;
                        }

                        .v-input__append-inner {
                            display: none !important;
                        }
                    }
                }
            }
        }

        .box__vehicle--search--minwidth {
            input {
                border-radius: 0 !important;
            }
        }

        .box__vehicle--search--fullwidth {
            input {
                border-top-right-radius: 7px;
                border-bottom-right-radius: 7px;
            }
        }

        .box__vehicle--search {
            position: relative;

            input {
                width: 100%;
                height: 100%;
                background-color: $grey-light;
                font-size: 20px;
                font-weight: 500;
                letter-spacing: 1px;
                color: var(--v-primary-base);
                text-transform: uppercase;
                border: 0;
                padding: 8px 40px 8px 8px;
                margin: 0;
                outline: none !important;

                &::placeholder {
                    color: $grey-medium;
                }
                &::-webkit-input-placeholder {
                    color: $grey-medium;
                }
                &:-moz-placeholder {
                    color: $grey-medium;
                }
                &::-moz-placeholder {
                    color: $grey-medium;
                }
                &:-ms-input-placeholder {
                    color: $grey-medium;
                }
            }

            .btn-icon-search {
                border-top-right-radius: 7px;
                border-bottom-right-radius: 7px;
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                top: 0;
                right: 0;
                width: 40px;
                height: 100%;
                cursor: pointer;
                path,
                g {
                    stroke: var(--v-primary-base);
                }
                svg {
                    color: var(--v-primary-base);
                }
            }

            .btn-icon-clear {
                border-top-right-radius: 7px;
                border-bottom-right-radius: 7px;
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                top: 0;
                right: 0;
                height: 100%;
                width: 20px;
                margin-right: 5px;
                aspect-ratio: 1;
                cursor: pointer;
                path,
                g {
                    stroke: var(--v-primary-base);
                }
                svg {
                    color: var(--v-primary-base);
                }
            }
        }

        .btn-open-history {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 50px;
            height: 100%;
            font-size: 20px;
            font-weight: 700;
            color: $white;
            background: var(--v-primary-base);
            border: 0;
            padding: 0;
            margin: 0;
            border-radius: 7px;
            margin-left: 8px;
            cursor: pointer;
            transition: all 0.2s ease-in-out;

            &:hover {
                background-color: var(--v-primary-lighten5);

                svg {
                    rect,
                    path:last-child {
                        fill: var(--v-primary-base);
                    }
                }
            }
        }
    }
}
</style>
